import { render, staticRenderFns } from "./PaymentArticlesAddComponent.vue?vue&type=template&id=06a741d6&scoped=true"
import script from "./PaymentArticlesAddComponent.vue?vue&type=script&lang=ts"
export * from "./PaymentArticlesAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a741d6",
  null
  
)

export default component.exports